import { ReactNode, useCallback } from 'react';
import { Button } from '../Button/Button';

interface Props {
    id: string;
    onClick: (id: string) => void;
    children: ReactNode;
    variant?: 'primary' | 'outlined' | 'text';
    className?: string;
    color?: 'primary' | 'neutral' | 'danger';
    size?: 'normal' | 'small' | 'tiny';
    isLoading?: boolean;
    leftAddon?: ReactNode;
    rightAddon?: ReactNode;
    preventDefault?: boolean;
    ignoreFormStatus?: boolean;
    disabled?: boolean;
}

export function CallbackButton({
    id,
    onClick,
    children,
    variant,
    className,
    color,
    size,
    isLoading,
    leftAddon,
    rightAddon,
    preventDefault = false,
    ignoreFormStatus = false,
    disabled = false,
}: Props) {
    const handleClick = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    return (
        <Button
            variant={variant}
            className={className}
            color={color}
            size={size}
            isLoading={isLoading}
            leftAddon={leftAddon}
            rightAddon={rightAddon}
            preventDefault={preventDefault}
            ignoreFormStatus={ignoreFormStatus}
            onClick={handleClick}
            disabled={disabled}>
            {children}
        </Button>
    );
}
